/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SavedFieldMapping } from './SavedFieldMapping';
import {
    SavedFieldMappingFromJSON,
    SavedFieldMappingFromJSONTyped,
    SavedFieldMappingToJSON,
} from './SavedFieldMapping';

/**
 * 
 * @export
 * @interface FieldMappingData
 */
export interface FieldMappingData {
    /**
     * 
     * @type {string}
     * @memberof FieldMappingData
     */
    stotlesObjectType: FieldMappingDataStotlesObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingData
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingData
     */
    entitySetName: string;
    /**
     * 
     * @type {Array<SavedFieldMapping>}
     * @memberof FieldMappingData
     */
    fields: Array<SavedFieldMapping>;
}


/**
 * @export
 */
export const FieldMappingDataStotlesObjectTypeEnum = {
    Lead: 'LEAD',
    Bid: 'BID',
    Contact: 'CONTACT'
} as const;
export type FieldMappingDataStotlesObjectTypeEnum = typeof FieldMappingDataStotlesObjectTypeEnum[keyof typeof FieldMappingDataStotlesObjectTypeEnum];


/**
 * Check if a given object implements the FieldMappingData interface.
 */
export function instanceOfFieldMappingData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stotlesObjectType" in value;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "entitySetName" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function FieldMappingDataFromJSON(json: any): FieldMappingData {
    return FieldMappingDataFromJSONTyped(json, false);
}

export function FieldMappingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldMappingData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stotlesObjectType': json['stotlesObjectType'],
        'entityName': json['entityName'],
        'entitySetName': json['entitySetName'],
        'fields': ((json['fields'] as Array<any>).map(SavedFieldMappingFromJSON)),
    };
}

export function FieldMappingDataToJSON(value?: FieldMappingData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stotlesObjectType': value.stotlesObjectType,
        'entityName': value.entityName,
        'entitySetName': value.entitySetName,
        'fields': ((value.fields as Array<any>).map(SavedFieldMappingToJSON)),
    };
}

